module.exports = __webpack_public_path__ + "static/img/index-sys3.6494dd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-sys3.svg
// module id = yQ0H
// module chunks = 11